import { Skeleton } from "@mui/material";

function SkeltonProgress() {
  return (
    <>
      <Skeleton />
      <Skeleton animation="wave" />
      <Skeleton animation={false} />
      <Skeleton variant="rounded" height={60} />
      <Skeleton animation="wave" />
      <Skeleton animation={false} />
      <Skeleton />
      <Skeleton />
      <Skeleton animation="wave" />
      <Skeleton animation={false} />
      <Skeleton variant="rounded" height={60} />
      <Skeleton animation="wave" />
      <Skeleton animation={false} />
      <Skeleton />
    </>
  );
}

export default SkeltonProgress;
